export const menuItems = [
  { name: 'Pricing', link: 'https://node-ready.com/pricing/' },
  { name: 'Features', link: 'https://node-ready.com/features/' },
  // { name: 'Library', link: 'https://node-ready.com/' },
  { name: 'About', link: 'https://node-ready.com/about/' },
  { name: 'Contact', link: 'https://node-ready.com/contact/' },
];
